<template>
  <div>
    <b-card title="جزییات تیکت">
      <b-card-text>
        <b-form @submit="onSubmit">
          <b-row>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="نام کاربر:" label-for="input-2">
                <b-form-input id="input-2" v-model="ticket.name" :disabled="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="شماره تماس:" label-for="input-2">
                <b-form-input id="input-2" v-model="ticket.mobile" :disabled="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="شماره تیکت:" label-for="input-2">
                <b-form-input id="input-2" v-model="ticket.id" :disabled="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="عنوان تیکت:" label-for="input-2">
                <b-form-input id="input-2" v-model="ticket.subject" :disabled="true"
                  placeholder="عنوان تیکت"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-3" label="وضعیت:" label-for="input-3">
                <MDDropdown v-bind:group="1" v-model="ticket.mdid1_status"></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="تاریخ ثبت:" label-for="input-2">
                <b-form-input id="input-2" v-model="ticket.created_at" :disabled="true"
                  placeholder="تاریخ ثبت"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-2" label="اهمیت:" label-for="input-2">
                <MDDropdown v-bind:group="2" :disabled="true" v-model="ticket.mdid2_periority"></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" sm="6">
              <b-form-group id="input-group-3" label="دپارتمان:" label-for="input-3">
                <b-form-select :disabled="true" id="input-3" v-model="ticket.department_id"
                  :options="departments"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-text>
    </b-card>
    <b-row v-for="item in ticket.ticket_contents" v-bind:key="item.id">
      <b-col cols="2" v-if="!item.IsAdmin"></b-col>
      <b-col class="pt-5" cols="12">
        <b-card :bg-variant="item.IsAdmin ? 'primary' : 'info'" text-variant="white">
          <b-card-text style="white-space: break-spaces">
            {{ item.text }}
            <br />
            <div class="attach-content" v-if="item.files.length">
              <b-link class="attach-css" target="_blank" v-for="(file, index) in item.files" v-bind:key="index"
                v-bind:href="file.fileUrl">&nbsp;&nbsp;&nbsp;&nbsp; دانلود فایل پیوست
                {{ index + 1 }}</b-link>
            </div>

            <hr />
            <b-row>
              <b-col>
                <span>{{ item.fullName }}</span>
              </b-col>
              <b-col>
                <span style="float: left">{{ item.created_at }}</span>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="2" v-if="item.IsAdmin"></b-col>
    </b-row>
    <TicketsReply :answer="answer" @change="change" :isBusyTechnical="isBusyTechnical" @SendAnswer="SendAnswer"
      @AssignToTechnical="AssignToTechnical" @CloseTicket="CloseTicket" @delete_attachment="delete_attachment"
      @uploadFile="uploadFile" />
  </div>
</template>
<style>
.attach-css,
.attach-css:hover {
  display: inline-block;
  margin: 10px;
  color: white;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import routesMap from "@/helpers/routesMap";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
import fileUploader from "@/components/fileUploader2";
import TicketsReply from "@/pages/Tickets/TicketsReply.vue";
export default {
  name: "tickets",
  data: function () {
    return {
      ticket: {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        files: [],
      },
      answer: {
        id: 0,
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        files: [],
      },
      departments: [],
      isBusyTechnical: false,
      routesMap,
    };
  },
  components: {
    MDDropdown,
    fileUploader,
    TicketsReply,
  },
  created() { },
  methods: {
    uploadFile(files) {
      this.answer.files = files;
    },
    SendAnswer: function () {
      this.answer.id = this.$route.params.id;
      httpHelper.postData("tickets", this.answer).then((res) => {
        if (res.success) {
          this.Loaded();
          this.answer.text = null;
        } else {
          this.$makeToast("danger", "خطا در ارسال تیکت", res.error[0], 5000);
        }
      });
    },
    CloseTicket: function () {
      this.ticket.mdid1_status = 5;
      httpHelper
        .patchData(`tickets/${this.$route.params.id}/close`, {
          mdid1_status: this.ticket.mdid1_status,
        })
        .then((res) => {
          this.Loaded();
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.ticket.text = null;
      httpHelper.postData("tickets", this.ticket).then((res) => {
        this.Loaded();
      });
    },
    Loaded: async function () {
      this.ticket = {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        ticket_contents: [],
        files: [],
      };
      try {
        const res = await httpHelper.getData("tickets?id=" + this.$route.params.id);
        this.ticket.id = this.$route.params.id;
        this.ticket.subject = res.result.subject;
        this.ticket.department_id = res.result.ticket_departments.id;
        this.ticket.mdid2_periority = res.result.ticket_periority.id;
        this.ticket.mdid1_status = res.result.ticket_status.id;
        this.ticket.created_at = persianDate.getDate(res.result.created_at);
        this.ticket.ticket_contents = this.ticket.ticket_contents = await Promise.all(res.result.ticket_contents.map(
          async (element) => {
            element.files.forEach(async (file, index) => {
              const imageUrl = await httpHelper.getImage(file.file_id);
              this.$set(element.files[index], 'fileUrl', imageUrl.result.url || '');
            });
            return {
              IsAdmin: element.IsAdmin,
              text: element.text,
              fullName: element.fullName,
              created_at:
                persianDate.getDate(element.created_at) +
                " , " +
                persianDate.getTime(element.created_at),
              files: element.files,
              image:
                element.image == "media/users/default.jpg"
                  ? "media/users/default.jpg"
                  : element.fileUrl,
            };
          }
        ));
        this.ticket.name = res.result.user.name;
        this.ticket.mobile = res.result.user.mobile;
      } catch (err) {
        console.error("Error loading ticket:", err);
      }
    },
    change(e) {
      Object.assign(this.answer, { text: e[0].description });
    },
    delete_attachment(index) {
      this.ticket.files.splice(index, 1);
    },
    cancel() {
      this.answer = {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        files: [],
      };
    },
    AssignToTechnical() {
      this.isBusyTechnical = true;
      httpHelper
        .patchData(`tickets/${this.$route.params.id}/assign-to-technical`)
        .then((res) => {
          this.Loaded();
        })
        .finally(() => {
          this.isBusyTechnical = false;
        });
    },
  },
  mounted() {
    httpHelper.getData("departments").then((res) => {
      this.Loaded();
      this.departments = res.result.map((element) => {
        return {
          value: element.id,
          text: element.name,
        };
      });
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "تیکت ها", route: "/tickets" },
      { title: "جزییات تیکت" },
    ]);
  },
};
</script>
